import ApiService from "@/common/api.service"

export const EthnicityService = {
    create(params) {
        return ApiService.post("ethnicities/add", params);
    },
    update(slug, params) {
        return ApiService.update("ethnicities", slug, params);
    },
}
